import BaseProgressBar from "./BaseProgressBar.vue";

export default BaseProgressBar;
